/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sidebar_Delete_Chats_TitleInputs */

const es_sidebar_delete_chats_title = /** @type {(inputs: Sidebar_Delete_Chats_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Eliminar ${i?.count} chats?`)
};

const en_sidebar_delete_chats_title = /** @type {(inputs: Sidebar_Delete_Chats_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.count} chats?`)
};

/**
* | output |
* | --- |
* | "Delete {count} chats?" |
*
* @param {Sidebar_Delete_Chats_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const sidebar_delete_chats_title = /** @type {((inputs: Sidebar_Delete_Chats_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Delete_Chats_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_sidebar_delete_chats_title(inputs)
	return en_sidebar_delete_chats_title(inputs)
});
export { sidebar_delete_chats_title as "sidebar.delete_chats_title" }